class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.activeElement = null;
    this.hideNotification();
  }

  hideNotification() {
    if (!this.notification) return;
    this.notification.hidden = true;
    this.notification.setAttribute('aria-hidden', 'true');
    this.notification.classList.remove('active', 'animate');
  }

  open() {
    this.hideNotification();
  }

  close() {
    this.hideNotification();
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState) return;
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];
      if (!target || !html) return;
      const innerHTML = this.getSectionInnerHTML(html, section.selector);
      if (innerHTML !== null) target.innerHTML = innerHTML;
    });

    if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
    this.close();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = documentFragment.querySelector(selector);
    return selectedElement ? selectedElement.innerHTML : null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
